export enum AssignFilterColumns {
  CITY = 'cities',
  POINT_NAME = 'name',
  ADDRESS = 'address',
  EMAIL = 'email',
  CHECKBOX = 'id',
}
